import styled from 'styled-components';

export const StyledResultTableWrapper = styled.div`
    button {
        border-radius: 50px;
    }

    .marginBottom {
        margin-bottom: 30px;
    }

    .info-text {
        font-size: 26px;
        text-align: center;
    }
`